import React, { useContext } from "react";

import { EventContext, SportOfferContext } from "@gp/components";
import { useOfferOptionsContext } from "@state/hooks/offer/useOfferOptionsContext";
import { observer } from "mobx-react";

import { AggregatedScore } from "./components/AggregatedScore";
import { LiveMatchResult } from "./components/LiveMatchResult";
import { OfferColumnResult } from "./components/OfferColumnResult";
import { OfferHistoryResult } from "./components/OfferHistoryResult";

export const EventResult = observer(function EventResult() {
	const sport = useContext(SportOfferContext);
	const hasResultPerSet = [
		"tennis",
		"table-tennis",
		"volleyball",
		"badminton",
	].includes(sport.abrv);
	const offerOptions = useOfferOptionsContext();

	if (offerOptions.isOfferHistory) {
		return <OfferHistoryResult />;
	}
	if (hasResultPerSet) {
		return <OfferColumnResult />;
	}

	return <LiveMatchResultWrapper />;
});

const LiveMatchResultWrapper = observer(function LiveMatchResultWrapper() {
	const event = useContext(EventContext);
	const sport = useContext(SportOfferContext);

	return (
		<>
			<AggregatedScore event={event} />
			{event.isLive && <LiveMatchResult event={event} sport={sport} />}
		</>
	);
});
